// extracted by mini-css-extract-plugin
export default {"c-field-label":"substitute_c-field-label__ep3VU","link_new":"substitute_link_new__O3yIt"};